// extracted by mini-css-extract-plugin
var _1 = "TeamButton-module__logoContainer--Ylho0";
var _2 = "TeamButton-module__teamButton--i5eva";
export { _1 as "logoContainer", _2 as "teamButton" }
